module.exports = __webpack_public_path__ + "static/img/icon-ge-004.3b7e094.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-ge-004.png
// module id = jxPK
// module chunks = 1